<footer class="border-t border-slate-200 bg-white">
  <div class="mx-auto max-w-8xl px-4 py-12 sm:px-6 lg:px-8">
    <div class="flex flex-col items-start justify-between gap-8 md:flex-row md:items-center">
      <!-- Brand -->
      <div class="max-w-sm">
        <a routerLink="/" class="inline-flex items-center gap-2">
          <img
            src="/assets/images/logo.png"
            alt="Edutrip"
            class="h-32 w-64 rounded-lg object-contain"
          />
        </a>
        <p class="mt-4 text-sm text-slate-500">
            <span class="font-bold">Edutrip Malaysia</span> is a one-stop platform for educational trips, experiential learning programmes, and student-focused travel experiences locally and internationally.
        </p>
      </div>

      <!-- Links -->
      <nav class="flex flex-wrap gap-x-8 gap-y-2">
        @for (link of links; track link.path) {
          <a
            [routerLink]="link.path"
            class="text-sm font-medium text-slate-600 transition-colors hover:text-indigo-600"
          >
            {{ link.label }}
          </a>
        }
      </nav>
    </div>

    <div class="mt-10 border-t border-slate-200 pt-6">
      <ng-container *transloco="let t">
        <p class="text-xs text-slate-400" [innerHTML]="t('footer.copyright', { year })"></p>
      </ng-container>
    </div>
  </div>
</footer>
